module.exports = __webpack_public_path__ + "static/img/newUrl.e2298c58.gif";